<template>
	<span>
				<b-row class="mt-3 mb-2 m-0">
					<b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
						<!-- <h3>Manage Brands Banner</h3> -->
					</b-col>
					<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
						<b-button variant="dark" pill class="mr-2" @click="showAddModal()"><b-icon class="mr-2" icon="plus" aria-hidden="true" size="sm"></b-icon>Add Banner</b-button>
						
					</b-col>
				</b-row>
				<b-container fluid class="my-2">
				<b-row class="m-0">
					<b-col class="col-md-12 col-sm-12 col-xs-12">
						<div class="container-box">
							<b-row class="mt-4 px-3">
								<b-col lg="6" class="text-left">
									<span class="mr-2">Show</span>
									<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
									</b-form-select>
									<span class="ml-2">entries</span>
								</b-col>
								<b-col lg="4" offset-md="2">
									<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
										<b-input-group size="sm">
											<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
											</b-form-input>
											<b-input-group-append>
												<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
											</b-input-group-append>
										</b-input-group>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="px-3 pt-3">
								<b-col lg="12">
									<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
										
										<!--<template v-slot:cell(actions)="row">
											<b-button pill variant="primary" class="mr-1 icon-btn" @click="showUpdateModal(row.item, row.index, $event.target)"><b-icon icon="pencil" font-scale="1.6" ></b-icon></b-button>
											<b-button pill variant="danger" class="mr-1 icon-btn" @click="showDeletebannerModal(row.item)"><b-icon icon="trash" font-scale="1.6" ></b-icon></b-button>
										</template> -->
										<template v-slot:cell(status)="row">
											<b-badge pill variant="warning" v-if="row.value == 0"><b-link @click="setStatusbanner(row.item,1)">In Active</b-link></b-badge>
											<b-badge pill variant="success" v-else><b-link @click="setStatusbanner(row.item,0)">Active</b-link></b-badge>										
										</template>
										<template v-slot:cell(image)="row">
											<b-img v-bind="thumbnailProps" rounded alt="" v-if="row.value==''" :src="$root.MEDIAPATH+'blank.jpg'">{{row}}</b-img>
											<b-img v-bind="thumbnailProps" rounded alt="" v-else :src="$root.MEDIAPATH+'brands/banner/'+row.value.replace('_rg','_th')" width="120px">{{row}}</b-img>
										</template>
										<template v-slot:cell(actions)="row">
											<!--<b-button pill variant="primary" class="mr-1 icon-btn" @click="showUpdateModal(row.item, row.index, $event.target)"><b-icon icon="pencil" font-scale="1.6" ></b-icon></b-button>-->
											<b-button pill variant="outline-danger" class="mr-1 icon-btn" @click="showDeletebannerModal(row.item)"><b-icon icon="trash" font-scale="1.6" ></b-icon></b-button>
										</template>
									</b-table>
								</b-col>
							</b-row>
							<b-row class="px-3">
								<b-col lg="6" class="text-left">
									<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
								</b-col>
								<b-col lg="3" offset-md="3">
									<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
								</b-col>
							</b-row>
						</div>
					</b-col>
				</b-row>
				
				 
					<b-modal id="my-modelbanner" title="Add Banner" size="md">
						<form ref="form" >
							<b-container fluid>
								
										<b-row class="mb-1">
											<b-col cols="12">
												<b-row class="mb-3">
													<b-col cols="3" class="text-right"><label class="font-sm">Brand Name</label></b-col>
													<b-col>
													
													<b-form-group :state="bannerState.brand_id"  label-for="brandId-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Brand is required!" >
														<b-form-select v-model="banner.brand_id" id="brandId-input" :state="bannerState.brand_id" v-on:change="bannerState.brand_id = null">
														<b-form-select-option value="" hidden selected placeholder="select State">*Select Brand</b-form-select-option>
														<b-form-select-option v-for="option in brands" :key="option.id" :value="option.id">{{option.brand_name}}</b-form-select-option>
														</b-form-select>
													</b-form-group>
													
													
													</b-col>
												</b-row>
												
												<b-row class="mb-3">
													<b-col cols="3" class="text-right"><label class="font-sm">Banner Image</label></b-col>
													<b-col>
														<b-form-group :state="bannerState.brand_id"  label-for="brandimage-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Banner image is required!" description="Banner size should be 1140 X 280 px !">
														
														<b-form-file type="file" v-model="product_inf.product_image_1" id="brandimage-input" :state="bannerState.image" v-on:change="bannerState.image = null" accept=".jpeg,.jpg,.png" size="sm" placeholder="Choose a Image"></b-form-file>
														
														
														</b-form-group>
														
													</b-col>
												</b-row>
												
												<b-row class="mb-3">
													<b-col cols="3" class="text-right"><label class="font-sm">Status</label></b-col>
													<b-col cols="4">
														
														<b-form-group :state="bannerState.status"  label-for="bannerstatus-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Status is required!">
														<b-form-select v-model="banner.status" id="bannerstatus-input" :state="bannerState.status" v-on:change="bannerState.status = null">
														<b-form-select-option value="" hidden selected placeholder="select State">*Select status</b-form-select-option>
														<b-form-select-option value="1">Active</b-form-select-option>
														<b-form-select-option value="0">In Active</b-form-select-option>
														</b-form-select>
													</b-form-group>
														
														
													</b-col>
												</b-row>
												
												
											</b-col>
										</b-row>
									
								
							</b-container>
						</form>
						<template v-slot:modal-footer="{ ok, close }">
							<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
							<b-button size="sm" variant="success" @click="modalbannerSubmit">Submit</b-button>
						</template>
					</b-modal>			
			</b-container>				
		</span>		
	</template>
<script>
//import CartVariant from "@/components/cartVariant.vue";
export default {
  name: 'BrandBanner',
  components: {
  //"cart-variant": CartVariant,
  },
  props: {
  brands: { type: Array },
    /* cartData: { type: Object  }, 
	cartTotalqty:Number,*/
  },
  mounted(){
  this.initload();
  //this.initProfile();
  
  },
  computed: {
    //
  },
  data() {
    return{		
		banner:{
				brand_id:'',
				image:'',				
				status:'',				
			},
		bannerState:{
			brand_id:null,
			image:null,
			status:null,
		},		
		product_inf:{},
		thumbnailProps: { blank: false, width: 80, height: 80, class: 'm1' },
			recordUrl: this.$root.WEBAPI+'sellerapi/brandbanner-record',
			insertUrl: this.$root.WEBAPI+'sellerapi/brand-insert',
			updateUrl: this.$root.NEWAPIURL+'sellerapi/brandbannerupdate',
			deleteUrl: this.$root.WEBAPI+'sellerapi/brandbanner-delete',
			setstatusUrl: this.$root.WEBAPI+'sellerapi/brandbanner-setstatus',
			csvgenUrl: this.$root.WEBAPI+'sellerapi/product-csvgen',
			filteredCategory: [],
			category: [],
			records: [],
			categoryOptions: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Brands',
					active: true
				}
			],
			fields: [				
				{ key: 'brand_name', label: 'Brand'},				
				{ key: 'image', label: 'Image'},
				{ key: 'status', label: 'Status' },
				{ key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {
				about_brand: '',
				short_description: '',
				product_data:{}, 
				tier_price:[], 
				gallery_images:["","","",""]
			},
		
		
		
	}
  },
  methods:{
	initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.products;
					//console.log(self.records); 
					//self.category = response.data.result.category; 
					self.loading = false;
					self.totalRows = self.records.length;

					self.filteredCategory = [];
					//self.filterChildCategory(0, 0, 0);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
		
	},
	showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-modelbanner');
		},
		showDeletebannerModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete Brand!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						delete_id: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		setStatusbanner(item,status){
				var self = this;
				this.$bvModal.msgBoxConfirm('Please confirm that you want to Cahnge Banner Status!.', {
					title: 'Please Confirm',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'danger',
					okTitle: 'YES',
					cancelTitle: 'NO',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if(value == true){
						self.axios.post(self.setstatusUrl, {
							accesskey: self.$session.get('access_key'),
							delete_id: item.id,
							status: status,
						})
						.then(function (response) {
							if(response.data.error == 0 || response.data.error == '0'){
								self.$bvToast.toast(response.data.message, {
									title: 'Status',
									toaster: 'b-toaster-bottom-right',
									autoHideDelay: 5000,
									variant: 'warning',
									solid: true,
									appendToast: true
								});
								self.initload();
							}
							
						})
						.catch(function (error) {
							alert(error);
						});
					}else{
						//alert('no '+item.id);
					}
				})
				.catch(err => {
					// An error occurred
					console.log(err);
				})
			},
		modalbannerSubmit(){
			var valid = true;

			if(this.banner.brand_id=='') {
				this.bannerState.brand_id = false;
				valid = false;
			}else this.bannerState.brand_id = true;
			
		if(this.product_inf.product_image_1=='') {
				this.bannerState.image = false;
				valid = false;
			}else if(typeof this.product_inf.product_image_1==='undefined') {
				this.bannerState.image = false;
				valid = false;
			}else this.bannerState.image = true;
			
			if(this.banner.status=='') {
				this.bannerState.status = false;
				valid = false;
			}else this.bannerState.status = true;
		
		
			if(valid){
				var self = this;
				self.loading = true;
				//bvModalEvt.preventDefault();
				var submitUrl = "";				
				submitUrl = self.updateUrl;
				let formData = new FormData();
				formData.append('imagefile1', this.product_inf.product_image_1);				
				formData.append('data', JSON.stringify(this.banner));
				formData.append('accesskey', this.$session.get('access_key'));

				self.axios.post(submitUrl, formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				})
				.then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
						self.$bvModal.hide('my-modelbanner');
						self.$bvToast.toast(response.data.message, {
							title: 'Status',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 5000,
							variant: 'success',
							solid: true,
							appendToast: true
						});
						
						self.banner={
								brand_id:'',
								image:'',				
								status:'',				
							};
						self.bannerState={
							brand_id:null,
							image:null,
							status:null,
						};
						self.initload();
					}
					
				})
				.catch(function (error) {
					alert(error);
				});
			}
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		
	


    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   lang="scss">


</style>
